export default {
    namespaced: true,
    state: {
    },
    mutations: {
    },
    actions: {
        deleteDocument({commit}, id) {
            return axios.delete(`/api/hope/documents/${id}`);
        }
    },
    getters: {

    }
}
